import axios from "axios";

const FetchList = (params, config) => {
  return axios.get("/api/v1/billing", { params, ...config });
};

const FetchCompanies = (reseller_id, params, config) => {
  return axios.get(`/api/v1/billing/${reseller_id}`, {
    params,
    ...config,
  });
};

const ApiBilling = {
  FetchList,
  FetchCompanies,
};

export default ApiBilling;
